import { render, staticRenderFns } from "./SplitTransloadAndDeliver.vue?vue&type=template&id=849a1692&scoped=true"
import script from "./SplitTransloadAndDeliver.vue?vue&type=script&lang=js"
export * from "./SplitTransloadAndDeliver.vue?vue&type=script&lang=js"
import style0 from "./SplitTransloadAndDeliver.vue?vue&type=style&index=0&id=849a1692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849a1692",
  null
  
)

export default component.exports